export const environment = {
    production: true,
    env: 'stage',
    dsn: 'https://acc251c3b6cbaedba64ada236877b973@o4509167942828032.ingest.de.sentry.io/4510080535298128',
    envVar: {
        backendUrl: 'https://portail-print.cityzmedia.fr/backend/',
        socketUrl: 'wss://ws-print.cityzmedia.io:443',
    },
    features: {
        batRequestFlowEnabled: true, // This is a feature specific for the French market
        importAddressesEnabled: false,
        weekNumbersEnabled: true,
    }
};
